// Simple add to cart and redirect to cart page
(function() {
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form) return;
    if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn && submitBtn.disabled) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function(res) {
      if (!res.ok) {
        return res.json().then(function(data) {
          throw new Error(data.description || 'Add to cart failed');
        });
      }
      window.location.href = '/cart';
    })
    .catch(function(err) {
      alert(err.message);
    });
  }, true);
})();
